<div class="margin-bottom-20 cf">
    <button type="button" style="display:none" id="hdnSalesHistory" class="btn  btn-circle btn-green margin-bottom pull-right"
            aria-controls="dropdown-basic" (click)="openSalesHistoryAdd(templateSolidDetails,6500,'panlestyle sold-modal')" tooltip="Add New Sale History" triggers="mouseenter:mouseleave"
            placement="left">
        <i aria-hidden="true" class="fa fa-plus icon"></i>
    </button>

    <button type="button" style="display:none" id="hdnLeasingHistory" class="btn  btn-circle btn-green margin-bottom pull-right"
            aria-controls="dropdown-basic" (click)="openSalesHistoryAdd(templateSolidDetails,6501, 'panlestyle sold-modal')" tooltip="Add New Lease History" triggers="mouseenter:mouseleave"
            placement="left">
        <i aria-hidden="true" class="fa fa-plus icon"></i>
    </button>
</div>


<div class="additionalFile-table">
    <table class="table basictable fixedlayouttable">
        <thead>
            <tr></tr>
        </thead>
        <tbody *ngFor="let item of lstSalesHistory; let i = index">
          <tr class="file-title" [ngClass]="{'show':item.showChild}">
            <td (click)="toggle_child(item, 0, i)">
              <span class="arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
              <i class="fa fa-calendar  margin-left-10" aria-hidden="true"></i>
              {{(getValue('Date', item) != null ? (_validationService.convertUTCDateToLocalDate1(getValue('Date', item)) | date: 'MM/dd/yyyy' ): item.EntryDate | date: 'MM/dd/yyyy')}}
            </td>
            <td *ngIf="item.Event != 'Sale'" colspan="4"><label>Event</label><p>{{item.Event != null ? item.Event : '-'}}</p></td>
            <td *ngIf="item.Event == 'Sale'"><label>Event</label><p>{{item.Event != null ? item.Event : '-'}}</p></td>
            <td *ngIf="item.Event == 'Sale'"><label>Sale Price</label><p>{{getValue('Sale Price', item) ? '$'+_validationService.decimalCommaFormat(getValue('Sale Price', item)):'-'}}</p></td>
            <td *ngIf="item.Event == 'Sale'"><label>Cap Rate</label><p>{{getValue('Sale Cap Rate', item) ? getValue('Sale Cap Rate', item)+'%':'-'}}</p></td>
            <td *ngIf="item.Event == 'Sale'"><p>{{getValue('Discount To Asking', item) != null && getValue('Discount To Asking', item) > 0 ? ('('+getValue('Discount To Asking', item) + '%)'): '(-)'}}</p></td>
            <td>
              <!--<p>PSF</p>-->
              <P class="text-right">
                <a *ngIf="showAddSaleHistory && !item.IsAutoGenerated && item.IsAutoGenerated != null" href="javascript:void(0);" (click)="openSalesHistoryEdit(templateSolidDetails,'panlestyle sold-modal', item, i)" class="blueone margin-left-10" tooltip="Edit" placement="left">
                  <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                </a>

                <a *ngIf="showAddSaleHistory" href="javascript:void(0);" (click)="openSalesHistoryDelete(DeleteModal,'deletemodal', item, i)" class="blueone margin-left-10" tooltip="Delete" placement="left">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
              </P>

            </td>

          </tr>
          <ng-container>
            <tr class="hide" [ngClass]="{'show':item.showChild}">
              <td colspan="6" style="padding:0" *ngIf="item.Event != 'Sale' && item.Event != 'Portfolio Sale'">
                <app-property-revison-list [historyFields]="item.PropertyRevisionFieldModels"></app-property-revison-list>
              </td>
              <td colspan="6" style="padding:0" *ngIf="item.Event == 'Sale' || item.Event == 'Portfolio Sale' ">
                <app-sale-history-detail [historyFields]="item.PropertyRevisionFieldModels"></app-sale-history-detail>
              </td>
            </tr>
          </ng-container>

          <tr class="hide tr-document" [ngClass]="{'show':item.showChild}">
            <td colspan="6">
              <a (click)="toggle_child(item,1,0)" class="margin-bottom-5">Documents: {{item.Documents != null && item.Documents != undefined ? item.Documents.length : 0}} </a>
              <table class="table row-border hover hide tr-document" [ngClass]="{'show':item.ShowDoc && item.Documents.length > 0}">
                <thead>
                  <tr>
                    <td>Title</td>
                    <td>Category</td>
                    <td>Uploaded By</td>
                    <td>Date</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let doc of item.Documents; let k= index">
                    <td>{{doc.Name}}</td>
                    <td>{{doc.Category ? doc.Category : '-'}}</td>
                    <td>{{doc.UploadedBy}}</td>
                    <td>{{doc.UploadedDate | date: 'MM/dd/yyyy'}}</td>
                    <td>
                      <p>
                        <a *ngIf="doc.Url != null && doc.Url != undefiend && doc.Url.length > 0" href="{{doc.Url}}" download target="_blank">
                          <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                        </a>
                        <span *ngIf="authService.Admin()||authService.SuperAdmin()" (click)="openDocumentDelete(DeleteDocument,'deletemodal', doc.Id, i)" tooltip="Remove" class="remove">
                          <i aria-hidden="true" class="icofont icofont-close"></i>
                        </span>
                      </p>
                    </td>

                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr class="hide tr-document" [ngClass]="{'show':item.showChild}" *ngIf="property?.IsPortfolio">
            <td colspan="6">
              <div class="collapse-box">
                <div (click)="toggle_child(item,3,0)" class="margin-bottom-15 d-flex">
                  <span>Properties: {{item.Properties != null && item.Properties != undefined ? item.Properties.length : 0}}</span>
                  <i aria-hidden="true" class="fa fa-angle-right ml-auto"></i>
                </div>
                <div class="table-responsive">
                  <table class="table row-border hover hide  property-table basictable" [ngClass]="{'show':item.ShowProp && item.Properties.length > 0}">
                    <thead>
                      <tr>

                        <th style="width:60px;" class="sticky-left">Property Id</th>
                        <th style="width:160px;" class="property-name-column sticky-left">Tenant Name</th>

                        <th style="width:30px;">State</th>
                        <th style="width:130px;">City</th>
                        <!--<th [hidden]="hideColumn(4)">Property Type</th>-->
                        <th style="width:60px;">Status</th>
                        <th style="width:60px;">Asking Price</th>
                        <th style="width:60px;">Rent / NOI</th>
                        <th style="width:60px;">Cap Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let prop of item.Properties;let i = index">

                        <td class="sticky-left">
                          <p class="whitespacenowrap">
                            {{ prop.PropertySequenceId }}
                          </p>
                        </td>
                        <td class="sticky-left">
                          <p>
                            <a href="#" routerLink="/viewproperty/{{prop.Guid}}" (click)="onRedirection();">{{ prop.PropertyName ? prop.PropertyName : prop.TenantName }}</a>
                          </p>
                        </td>

                        <td><p>{{prop.State ? prop.State : '-'}}</p></td>
                        <td><p>{{prop.City ? prop.City : '-'}}</p></td>
                        <!--<td [hidden]="hideColumn(4)"><p>{{prop.AssetType ? prop.AssetType : '-'}}</p></td>-->
                        <td><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">{{ prop.PropertyStatus }}</p></td>
                        <td><p class="whitespacenowrap">{{(prop.Price) ? '$ '+ (prop.Price | number:0) : '-'}}</p></td>
                        <td><p class="whitespacenowrap">{{(prop.RentNOI) ? '$ '+ (prop.RentNOI | number:0) : '-'}}</p></td>
                        <td *ngIf="prop.capratetext == 'ZCF'"><p>{{prop.capratetext}}</p></td>
                        <td *ngIf="prop.capratetext != 'ZCF'"><p>{{ (prop.CapRate) ? (prop.CapRate | number : '1.2-2') + '%' : '-' }}</p></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </td>
          </tr>
          <!--<tr>
      <td colspan="5" style="padding:0">&nbsp;</td>
  </tr>
  <tr class="hide tr-note" [ngClass]="{'show':item.showChild}">
      <td colspan="5">
          <div (click)="toggle_child(item,2,0)" class="margin-bottom-5" style="color:#0A3D5D;font-weight: 600;">NOI / Rent Schedule</div>
          <p>&nbsp;</p>
          <div class="hide col-md-12" [ngClass]="{'show':item.ShowRentTerm}">
              <div class="white-box table-box row">
                  <app-my-portfolio-property-history-rent-term [PropertyHistoryRentTerms]="item.SaleHistoryRentTerm" [saleDate]="item.SaleDate"></app-my-portfolio-property-history-rent-term>
              </div>
           </div>
      </td>
  </tr>-->
          <tr>
            <td colspan="6" style="padding:0">&nbsp;</td>
          </tr>
        </tbody>
        <tbody *ngIf="lstSalesHistory.length === 0">
            <tr>
                <td colspan="6">
                    <div class="nodata">
                        <i class="icofont icofont-warning icon"></i>
                        <p style="color:#878787">No Data Available</p>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>


<!--<ng-template #templateSolidDetails>
    <app-add-sales-history (save)="saveSalesDetails($event)" [currentSalesDetails]="salesHistory" (close)="closeModal($event)"></app-add-sales-history>
</ng-template>-->

<ng-template #templateSolidDetails>
    <app-property-revisions-add (save)="saveSalesDetails($event)" [property]="property" [currentSalesDetails]="salesHistory" (close)="closeModal($event)" [IsDataEntryProperty]="IsDataEntryPrperty" [IsFromAddEditPage]="IsFromAddEditPage" [revisionId]="revisionId" [transactionTypeId]="transactionTypeId"></app-property-revisions-add>
</ng-template>


<ng-template #DeleteModal>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete History</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure to delete this history ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="onHistoryDelete();modalRef.hide();">Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #DeleteDocument>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete Document</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure to delete this document ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="onRemoveDocument();modalRef.hide();">Delete</button>
        </div>
    </div>
</ng-template>
